const SOURCES = {
  dark: "/logo.png",
  light: "/logo-light.png",
};

export const Brand = ({ variant = "dark", className = "h-9 w-auto" }) => (
  <img
    src={SOURCES[variant]}
    alt="TUPU — Mide. Registra. Cumple."
    className={className}
    data-testid={`brand-logo-${variant}`}
  />
);
